module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG0001-a0d0bed1e222ee81dae7eeeddb3461f1.png";